module.exports = __webpack_public_path__ + "media/site_templates/www.buildersnearme.net.au/images/our_services_1-93a289386067eeb5ba356efcf9d1742f.jpg";